import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/system';
import useMediaQuery from '@mui/material/useMediaQuery';
import lightMode from '../assets/logo/lightmode.png';
import darkMode from '../assets/logo/darkmode.png';

const whiteLogos = [darkMode];

const darkLogos = [lightMode];

export default function BrandLogo() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const logos = theme.palette.mode === 'light' ? darkLogos : whiteLogos;

  const logoStyle = {
    width: 'auto',
    height: isMobile ? '300px' : '500px',
    opacity: 1
  };

  return (
    <Box id="brandLogo" sx={{ py: 4 }}>
      <Grid container justifyContent="center" sx={{ mt: 0.5, opacity: 0.6 }}>
        {logos.map((logo, index) => (
          <Grid item key={index}>
            <img src={logo} alt={`Fake company number ${index + 1}`} style={logoStyle} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
